import React, { useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchData, search } from "../../../_actions/sidebarSliderActions";
import { prepareGifPayload } from "../../../_utils/common";
import { ImageItemWithoutDrag } from "../../../_components/common/statelessView";
import SuperList from "../../../_components/details/sidebarPanels/mediaPanel/SuperList";

const GiphyList = ({ onItemClick, onItemDrag }) => {
  const dispatch = useDispatch();
  const sidebarSlider = useSelector((state) => state.sidebarSlider);

  const handleItemClick = useCallback(
    (data) => {
      onItemClick?.(data);
    },
    [onItemClick]
  );

  const handleItemDrag = useCallback(
    (event, data) => {
      onItemDrag?.(event, data);
    },
    [onItemDrag]
  );

  const handleLoadPage = useCallback(
    (groupKey) => {
      const params = {
        panelType: sidebarSlider.sliderPanelType,
        page: sidebarSlider.page,
        searchText: sidebarSlider.searchText,
        groupKey,
      };

      if (!sidebarSlider.searchText) {
        dispatch(fetchData(sidebarSlider.source, params));
        return;
      }

      dispatch(search(sidebarSlider.source, sidebarSlider.searchText, params));
    },
    [dispatch, sidebarSlider]
  );

  const childElements = useMemo(() => {
    return sidebarSlider.payload.map((itemData) => {
      if (!itemData?.images?.preview_gif?.url) {
        return null;
      }

      const itemPayload = prepareGifPayload(sidebarSlider.source, itemData, {
        width: 0,
        height: 0,
      });

      return (
        <div
          key={itemData.id}
          className="item"
          onClick={onItemClick ? () => handleItemClick(itemPayload) : null}
          onDragStart={
            onItemDrag ? (event) => handleItemDrag(event, itemPayload) : null
          }
          draggable={!!onItemDrag}
          data-grid-groupkey={itemData.groupKey}
        >
          <ImageItemWithoutDrag
            data={itemPayload}
            key={itemData.id}
            url={itemData.images.preview_gif.url}
            alt={itemData.title}
            width={itemData.images.preview_gif.width}
            height={itemData.images.preview_gif.height}
            source={"Giphy"}
            showOverlayInfo={true}
          />
        </div>
      );
    });
  }, [
    sidebarSlider.source,
    sidebarSlider.payload,
    onItemClick,
    onItemDrag,
    handleItemClick,
    handleItemDrag,
  ]);

  return (
    <>
      <SuperList
        list="giphy-gallery"
        loaded={sidebarSlider.loaded}
        searchPlaceholder={"Search giphy"}
        notFound={"There are no giphy."}
        errorsView={null}
        hasMore={!!sidebarSlider.hasMore}
        loadPage={handleLoadPage}
        showRecents
        onClickRecent={(itemPayload) => {
          handleItemClick(itemPayload);
        }}
        onDragRecent={
          onItemDrag ? (event, data) => handleItemDrag(event, data) : null
        }
        recentsWithoutDragAndDropContext
      >
        {childElements}
      </SuperList>
    </>
  );
};

export default GiphyList;
